import { ImageConfig } from 'konva/lib/shapes/Image';
import React from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';

interface CanvasImageProps extends Omit<ImageConfig, 'image'> {
  src: string;
}

export const CanvasImage = React.memo<CanvasImageProps>(({ src, ...rest }) => {
  const [image] = useImage(src);
  return <Image image={image} {...rest} />;
});

CanvasImage.displayName = 'CanvasImage';
